import { Reducer } from 'redux';
import { SendFeedbackActionTypes, SendFeedbackState } from './types';

export const initialState: SendFeedbackState = {
  feedback: undefined,
  isSendingFeedback: false,
  feedbackError: undefined
};

const reducer: Reducer<SendFeedbackState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SendFeedbackActionTypes.SEND_FEEDBACK_START: {
      return {
        ...state,
        isSendingFeedback: true,
        feedback: undefined,
        feedbackError: undefined
      };
    }
    case SendFeedbackActionTypes.SEND_FEEDBACK_SUCCESS: {
      return {
        ...state,
        isSendingFeedback: false,
        feedback: action.payload,
        feedbackError: undefined
      };
    }
    case SendFeedbackActionTypes.SEND_FEEDBACK_FAILURE: {
      return {
        ...state,
        isSendingFeedback: false,
        feedback: undefined,
        feedbackError: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
